import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {ClientSidePermissionContainerModel} from '../../../../../models/aggregates/permissions';
import {Core2Config, Pagination, ApiVisa, ApiResponseModel} from '../shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientSidePermissionService extends BaseApiTemplateService<ClientSidePermissionContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'client-side-permissions';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'client-side-permissions';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'client-side-permissions';
    this.httpClient = http;
  }

  private setUrl(endpoint: string){
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'client-side-permissions' + endpoint;
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'client-side-permissions' + endpoint;
  }

  sysadminGetByCriteria(pagination: Pagination, apiVisa: ApiVisa){
    this.setUrl('/sysadmin-ep');
    return super.getByCriteria(pagination, apiVisa);
  }

  replicateDataToTenantSysadminEP(dtoObject: any, apiVisa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (apiVisa && apiVisa.api_domain_url != null) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path
    }
    const url = this.apiUrl + `update-tenant/sysadmin-ep`;
    return this.httpClient.post<ApiResponseModel<AnalyserOptions>>(
      url,
      dtoObject,
      this.getHttpHeader(apiVisa)
    );
  }

}
